// extracted by mini-css-extract-plugin
module.exports = {"textGroup":"user-settings_textGroup__3Gmyr","inputGroup":"user-settings_inputGroup__1fLnd","button":"user-settings_button__23a40","radioGroup":"user-settings_radioGroup__vmplf"};